// Compiled at 2026-10-07T06:21:14.844Z
// Auto-generated by Lowgile
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { BoInfoSymbol, OnAfterCodeLoad, HasChangedInternallySymbol } from "@lg/shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => GoalSettingGoalType.loadInternal(), entryList => {
        GoalSettingGoalType.θentryList.set(entryList)
        GoalSettingGoalType.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class GoalSettingGoalType {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["label", "futureGoal"] as const,
        allPropertyNames: ["id", "label", "futureGoal"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<GoalSettingGoalType.Id | null>;
    static readonly Id = String;
    static ids: GoalSettingGoalType.Id[] = [] as any;
    static idsAndDisplayValues: Record<GoalSettingGoalType.Id, string> = {} as any;
    static θentryList = signal<GoalSettingGoalType.Entry[] | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<GoalSettingGoalType.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'label';
    [immerable] = true;
    readonly θlabel = computed(() => {
        const id = this.θid()
        return id !== null ? GoalSettingGoalType.getEntryMap()[id]?.label : undefined
    });
    readonly θfutureGoal = computed(() => {
        const id = this.θid()
        return id !== null ? GoalSettingGoalType.getEntryMap()[id]?.futureGoal : undefined
    });
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return GoalSettingGoalType[BoInfoSymbol]
    }

    get __type(): 'Toolbox.GoalSettingGoalType' {
        return 'Toolbox.GoalSettingGoalType'
    }

    set __type(_) {
    }

    static get __type(): 'Toolbox.GoalSettingGoalType' {
        return 'Toolbox.GoalSettingGoalType'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id(): GoalSettingGoalType.Id | null {
        return this.θid()
    }

    set id(id: GoalSettingGoalType.Id | GoalSettingGoalType | null) {
        if (id !== null && typeof id == 'object') { id = id.id }

        if (id != null && !GoalSettingGoalType.getEntry(id as GoalSettingGoalType.Id)) throw new Error('Invalid id for type Toolbox.GoalSettingGoalType: ' + id)
        this.θid.set(id as GoalSettingGoalType.Id | null)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get ids(): GoalSettingGoalType.Id[] {
        return GoalSettingGoalType.ids
    }

    get idsAndDisplayValues(): Record<GoalSettingGoalType.Id, string> {
        return GoalSettingGoalType.idsAndDisplayValues
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[GoalSettingGoalType.$displayProperty])
    }

    get label() {
        return this.θlabel()
    }

    get futureGoal() {
        return this.θfutureGoal()
    }

    get isDevelopmentGoal() {
        return this.id == 'developmentGoal'
    }

    static get DevelopmentGoal() {
        return new this('developmentGoal')
    }

    get isPerformanceGoal() {
        return this.id == 'performanceGoal'
    }

    static get PerformanceGoal() {
        return new this('performanceGoal')
    }

    get isFutureDevelopmentGoal() {
        return this.id == 'futureDevelopmentGoal'
    }

    static get FutureDevelopmentGoal() {
        return new this('futureDevelopmentGoal')
    }

    get isFuturePerformanceGoal() {
        return this.id == 'futurePerformanceGoal'
    }

    static get FuturePerformanceGoal() {
        return new this('futurePerformanceGoal')
    }

    constructor(idOrObject: GoalSettingGoalType.Id | GoalSettingGoalType | null = null) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]): GoalSettingGoalType.Entry[] {
        return This.GoalSettingGoalType.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]): GoalSettingGoalType.Entry[] {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: GoalSettingGoalType.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof GoalSettingGoalType.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = GoalSettingGoalType.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<GoalSettingGoalType.Entry[]> {
        const dynamicEntryList = []
        this.θchoicesCache.clear()
        return LowgileDataUtil.createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new GoalSettingGoalType(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θtoIdAndOther(idOrObject: GoalSettingGoalType.Id | GoalSettingGoalType | null) {
        if (idOrObject && typeof idOrObject == 'object') {
            return { id: idOrObject.id }

        } else {
            return { id: idOrObject as GoalSettingGoalType.Id | null, otherValue: '' }

        }
    }

    θupdate(idOrObject: GoalSettingGoalType.Id | GoalSettingGoalType) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid.set(id)

    }

    static θonEntryListUpdated() {
        this.ids = this.getEntryList().map(e => e.id)
        this.idsAndDisplayValues = Object.fromEntries(this.getEntryList().map(e => [e.id, e.$displayValue] as const)) as Record<GoalSettingGoalType.Id, string>
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Toolbox.GoalSettingGoalType yet:', err.message)
            //throw err
        })
    }

    static $getSchema() {
        return z.string()
    }

    $getSchema() {
        return z.string()
    }

    setDevelopmentGoal() {
        this.id = 'developmentGoal'

    }

    setPerformanceGoal() {
        this.id = 'performanceGoal'

    }

    setFutureDevelopmentGoal() {
        this.id = 'futureDevelopmentGoal'

    }

    setFuturePerformanceGoal() {
        this.id = 'futurePerformanceGoal'

    }

    static θgetStaticEntryList() {
        return Object.freeze([
            Object.freeze({ id: "developmentGoal", label: "Development goal", futureGoal: false }),
            Object.freeze({ id: "performanceGoal", label: "Performance goal", futureGoal: false }),
            Object.freeze({ id: "futureDevelopmentGoal", label: "Future development goal", futureGoal: true }),
            Object.freeze({ id: "futurePerformanceGoal", label: "Future performance goal", futureGoal: true })
        ] as GoalSettingGoalType.Entry[]) as GoalSettingGoalType.Entry[]
    }
}
jsonClass('Toolbox.GoalSettingGoalType')(GoalSettingGoalType)

export const GoalSettingGoalTypeθId = String;

export type GoalSettingGoalTypeθId = string;

export namespace GoalSettingGoalType {
    export type Id = 'developmentGoal' | 'performanceGoal' | 'futureDevelopmentGoal' | 'futurePerformanceGoal'

    export interface Entry {
        id: GoalSettingGoalType.Id;
        label: string;
        futureGoal: boolean;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => GoalSettingGoalType.load(true))
